// react & material-ui
import React from 'react'
import Grid from '@material-ui/core/Grid'
import useTheme from '@material-ui/core/styles/useTheme'
import useMediaQuery from '@material-ui/core/useMediaQuery'

// hooks
import useProjectSiteVisitV2 from './useProjectSiteVisitV2'
import useCheckPermission from '../../../../../utilities/checkPermission'
import useTranslate from '../../../../../i18n/useTranslate'
import useAppFolderAndTabStore from '../../../../../stores/appFolderAndTab/appFolderAndTabStore'

// components
import Researcher from './researcher/researcher'
import Officer from './officer/officer'
import Dialog from '../../../../../control/dialog/dialog'
import Button from '../../../../../control/button/button'
import ButtonSubmittedWithdraw from '../../page/_sharedPageComponent/buttonSubmittedWithdraw/buttonSubmittedWithdraw'

// constants
import constSubmittedStep from '../../../../../constants/submittedStep'

type ProjectSiteVisitV2ViewType = ReturnType<typeof useProjectSiteVisitV2> & Omit<ProjectSiteVisitV2Type, 'projectMode'>

const ProjectProgressReportView: React.FC<ProjectSiteVisitV2ViewType> = (props) => {
    const {
        projectMode,
        isViewMode,
        configDialog,
        onRefDialog,
        onCallbackSaveComplete,
        onClickBackToSearch,
        projectData,
    } = props
    const checkPermission = useCheckPermission()
    const isUserResearcher = checkPermission.isUserResearcher()
    const translate = useTranslate()
    const theme = useTheme()
    const isMobileView = useMediaQuery(theme.breakpoints.down('xs'))

    const appFolderAndTabStore = useAppFolderAndTabStore()
    const currentSelectTab = appFolderAndTabStore.tabSelected?.stepID
    const canUpdateDocument = checkPermission.checkCanUpdateDocument(projectData)

    const checkConditionBtnClose = () => {
        let isEditDirector = false

        //เช็คว่ามีการกลับมาแก้ไขกรรมการมั้ย และไม่ใช่กรรมการเข้ามาใช่มั้ย (ปุ่มถอนยื่นต้องแสดงทุก step)
        if (projectData?.stepID) {
            isEditDirector = projectData?.stepID >= constSubmittedStep.submit && projectData?.committeeInfo.length >= 0
        }

        // เช็คว่าแก๊งประธานมาตรวจสอบเอกสารในขั้นตอนกำหนดประเภทโครงการมั้ย
        const isChairmanVerifyDoc =
            checkPermission.isUserChairman() && projectData?.stepID === constSubmittedStep.specifyProjectType

        // เช็คว่าผ่านstepการกำหนดประเภทโครงการและกรรมการไปรึยัง และกำลังเปิด tab กำหนดประเภทและกรรมการอยู่ใช่มั้ย
        const isChkStepEditDirector =
            currentSelectTab === constSubmittedStep.specifyProjectType &&
            projectData?.stepID !== constSubmittedStep.specifyProjectType

        let isBtnClose = isChairmanVerifyDoc ? false : isChkStepEditDirector ? isEditDirector : isViewMode

        return isBtnClose
    }

    const renderUserRoleComponent = () => {
        if (isUserResearcher) {
            return <Researcher projectMode={projectMode} callbackSaveComplete={onCallbackSaveComplete} />
        } else {
            return <Officer callbackSaveComplete={onCallbackSaveComplete} />
        }
    }

    return (
        <Grid container spacing={2}>
            <Grid container item>
                {renderUserRoleComponent()}
            </Grid>

            {checkConditionBtnClose() && !canUpdateDocument ? (
                <Grid container item justify="space-between" spacing={2}>
                    <Grid item xs={12} sm={'auto'}>
                        <ButtonSubmittedWithdraw gridProps={{ xs: false }} fullWidth={isMobileView ? true : false} />
                    </Grid>
                    <Grid item xs={12} sm={'auto'}>
                        <Button color="primary" onClick={onClickBackToSearch} fullWidth={isMobileView ? true : false}>
                            {translate.get('BUTTON.CLOSE')}
                        </Button>
                    </Grid>
                </Grid>
            ) : null}
            <Dialog onRef={onRefDialog} {...configDialog} />
        </Grid>
    )
}

export type ProjectSiteVisitV2Type = {
    projectMode: 'CREATE' | 'EDIT'
}
const ProjectSiteVisitV2: React.FC<ProjectSiteVisitV2Type> = (props) => {
    const projectSiteVisitV2 = useProjectSiteVisitV2(props)
    return <ProjectProgressReportView {...projectSiteVisitV2} />
}
export default ProjectSiteVisitV2
